<template>
  <map-selector class="page" />
</template>

<script>
import MapSelector from '@/components/MapSelector'

export default {
  name: 'MapsIndex',
  components: { MapSelector },
}
</script>
